const thousandsSeparator = (number: number, hasNoDecimal?: boolean) => {
	// On arrondit au supérieur / inférieur avant d'afficher ou non les décimales
	return hasNoDecimal ? Math.round((number + Number.EPSILON)).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ').split('.')[0] : (Math.round((number + Number.EPSILON) * 100) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ').replace('.', ',')
}

export default thousandsSeparator
